<script>
  import { onMount, onDestroy } from "svelte";
  import { Input } from "sveltestrap";
  import ColorPicker from "../../editorInterface/component/colorPicker.svelte";
  import {
    encodingMap,
    checkDashPattern,
  } from "../../editor/component/mark.js";
  export let currentEncoding,
    inputFocusAction,
    inputBlurAction,
    invalidDashPattern,
    currLayerPrev,
    updateEncoding,
    currLayer;

  // color picker;
  let showColorPicker = false;
  let afterPickAction;
  let pickerCurrentColor;
  function openColorPicker(action, curr) {
    showColorPicker = true;
    if (action.constructor.name === "Function") afterPickAction = action;
    pickerCurrentColor = curr;
  }
  function closeColorPicker() {
    showColorPicker = false;
    afterPickAction = undefined;
    pickerCurrentColor = undefined;
  }
  onMount(() => {
    showColorPicker = false;
  });
  onDestroy(() => {
    showColorPicker = false;
  });
</script>

<div class="dupo-menu-pane-form-row">
  {#if ["text", "dash"].includes(encodingMap[currentEncoding].input_type)}
    <Input
      type="text"
      name="static_value"
      id="static_value"
      autocomplete="off" 
      class="custom-form-select"
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      on:keyup={(event) => {
        if (encodingMap[currentEncoding].input_type === "dash")
          invalidDashPattern = !checkDashPattern(event.target.value);
        else invalidDashPattern = false;
      }}
      on:change={(event) => {
        if (!invalidDashPattern)
          updateEncoding(event, currentEncoding, "value", currLayerPrev);
      }}
      value={currLayer.mark[currentEncoding]?.value}
    />
  {:else if encodingMap[currentEncoding].input_type === "number"}
    <Input
      type="number"
      name="static_value"
      id="static_value"
      autocomplete="off" 
      class="custom-form-select"
      min={encodingMap[currentEncoding].min}
      max={encodingMap[currentEncoding].max}
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      on:change={(event) => {
        updateEncoding(event, currentEncoding, "value", currLayerPrev);
      }}
      value={currLayer.mark[currentEncoding]?.value}
    />
  {:else if encodingMap[currentEncoding].input_type === "color"}
    <div class="color-input">
      <div class="d-inline-block p-2">
        <i
          class="bi bi-square-fill"
          style={`color: ${
            currLayer.mark[currentEncoding]?.value || "black"
          };`}
        />
      </div>
      <span class="d-inline-block color-name p-2"
        >{currLayer.mark[currentEncoding]?.value || ""}</span
      >
      <div
        class="d-inline-block p-2"
        on:click={() => {
          openColorPicker((event) => {
            updateEncoding(event, currentEncoding, "value", currLayerPrev);
          }, currLayer.mark[currentEncoding]?.value || "rgba(0,0,0,1)");
        }}
      >
        <i class="bi bi-paint-bucket" alt="pick color" />
      </div>
    </div>
  {:else if encodingMap[currentEncoding].input_type === "select"}
    <Input
      type="select"
      name="static_value"
      id="static_value"
      class="custom-form-select"
      min={encodingMap[currentEncoding].min}
      max={encodingMap[currentEncoding].max}
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      on:change={(event) => {
        updateEncoding(event, currentEncoding, "value", currLayerPrev);
      }}
      value={currLayer.mark[currentEncoding]?.value}
    >
      <option value={undefined}>Select</option>
      {#each encodingMap[currentEncoding].input_values as v}
        <option value={v}>{v}</option>
      {/each}
    </Input>
  {/if}
</div>

<!-- color picker -->
{#if showColorPicker}
  <ColorPicker
    x="540px"
    y="300px"
    color={pickerCurrentColor}
    afterPick={afterPickAction}
    closer={closeColorPicker}
  />
{/if}
